module.exports = __webpack_public_path__ + "static/media/product_2.2c84b6c0.png";